/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {createStore, applyMiddleware, compose} from 'redux';
import reducers from 'store/reducers';
import socketMiddleWare from 'store/middleware/websocket';

export type {IAppStore} from 'store/reducers';

const middleware = [socketMiddleWare];
let composeEnhancer = null;

if (window['__REDUX_DEVTOOLS_EXTENSION__'] as typeof compose) {
  composeEnhancer = compose(applyMiddleware(...middleware), window['__REDUX_DEVTOOLS_EXTENSION__']() as typeof compose);
} else {
  composeEnhancer = compose(applyMiddleware(...middleware));
}

const store = createStore(
  reducers,
  composeEnhancer
);

export default store;